module.exports = __webpack_public_path__ + "img/img_049@2x.4c995486.png";